/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_data_table_accepted = /** @type {(inputs: {}) => string} */ () => {
	return `Aceptada`
};

const en_persons_data_table_accepted = /** @type {(inputs: {}) => string} */ () => {
	return `Accepted`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_data_table_accepted = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_data_table_accepted(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_data_table_accepted", locale)
	if (locale === "es") return es_persons_data_table_accepted(inputs)
	return en_persons_data_table_accepted(inputs)
};
export { persons_data_table_accepted as "persons.data_table.accepted" }